export default __webpack_public_path__ + "static/media/groups-midfield.d515f633.svg";